// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonErrorApiCodeResourcesExam = {
  examAttempt: "試験解答",
  examExam: "試験",
  examPaper: "試験問題用紙",
  examPaperItem: "試験問題項目",
  examPaperVersion: "試験問題用紙バージョン",
  examPlatform: "試験プラットフォーム",
  examReview: "試験レビュー",
  examUser: "試験ユーザー",
  examAuth: "試験認証",
  examScoring: "試験採点",
  examSystem: "試験システム",
  examExecutionFabric: "試験 Execution Fabric",
  examTaskCenter: "試験タスクセンター",
} as const;
